import React, { useState, createContext, useEffect } from 'react';
import {auth} from '../firebase/firebaseConfig';

export const AuthContext = createContext();


export const AuthProvider = ({children}) => {

  const [ currentUser, setCurrentUser ] = useState();
  const [loading, setLoading] = useState(true);
  

  

    function signup(email, password){
        return auth.createUserWithEmailAndPassword(email, password);
        //returns a promise dont remove it..
    }
    function login(email, password){
      return auth.signInWithEmailAndPassword(email, password);
    }

    function logout(){
      return auth.signOut();   
    }

    function resetPassword(email){
      return auth.sendPasswordResetEmail(email);
    }

    function updateUserEmail(email){
      return currentUser.updateEmail(email);
    }

    function updateUserPassword(password){
      return currentUser.updatePassword(password);
    }

  useEffect(()=>{
    const unsub = auth.onAuthStateChanged((user)=>{
        setCurrentUser(user);
        setLoading(false);
    })
    return unsub;
  },[])

  const value={
    currentUser,
    signup,
    login,
    logout,
    resetPassword,
    updateUserEmail,
    updateUserPassword
   }
    return ( 
        <div>
            <AuthContext.Provider value = {value}> 
                { !loading && children }
            </AuthContext.Provider>
            
        </div>
     );
}
 
export default AuthProvider;